<div [id]="id" class="igo-map-browser-target"></div>
<ng-content />
